import Swiper from "swiper";
import { A11y, Navigation } from "swiper/modules";
import "@/styles/components/slider.css";

document.querySelectorAll(".element-productfeatureimages").forEach((el) => {
  const container = el.querySelector(".swiper");

  new Swiper(container, {
    modules: [A11y, Navigation],
    autoplay: {
      delay: 3000,
      pauseOnMouseEnter: true,
    },
    slidesPerView: 1,
    spaceBetween: 16,
    speed: 700,
    navigation: {
      nextEl: el.querySelector(".slider-button-next"),
      prevEl: el.querySelector(".slider-button-prev"),
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 30,
      },
    },
  });
});
